import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createTranslator, getPortalLocale, intlDateLocale } from "../lib/i18n";

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => getPortalLocale());

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const value = useMemo(() => {
    const t = createTranslator(locale);
    return { locale, setLocale, t, dateLocale: intlDateLocale(locale) };
  }, [locale]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error("useLocale must be used within LocaleProvider");
  }
  return context;
}
